var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-collapse",
    { attrs: { title: "Matrícula" } },
    [
      _c("el-row", [
        _c(
          "div",
          { staticClass: "breakText" },
          [
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c("app-display", {
                  attrs: {
                    label: "CNS:",
                    content: _vm.getValue(_vm.imovel.cnsMatricula)
                  }
                }),
                _c("app-display", {
                  attrs: {
                    label: "Número:",
                    content: _vm.getValue(_vm.imovel.numeroMatricula)
                  }
                })
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c("app-display", {
                  attrs: {
                    label: "Livro:",
                    content: _vm.getValue(_vm.imovel.livroMatricula)
                  }
                }),
                _c("app-display", {
                  attrs: {
                    label: "N° da folha:",
                    content: _vm.getValue(_vm.imovel.numeroFolhaMatricula)
                  }
                })
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "inputDiv", attrs: { span: 12 } },
              [
                _c("app-display", {
                  attrs: {
                    label: "Data da matrícula:",
                    content: _vm.formatDate(_vm.imovel.dataMatricula)
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42aaff80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42aaff80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/common/InfoMatricula.vue
// module id = null
// module chunks = 